import { faFileArrowDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC, createRef, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { B2Button } from "src/shared/@hdb/biome-2";
import { getDeviceByBlock } from "src/store/slices/dms-dashboard.slice";
import { getBlocksBySiteCode } from "src/store/slices/location-block.slice";
import { getSiteByTCCode } from "src/store/slices/location-site.slice";
import { getTownCouncils } from "src/store/slices/town-council.slice";
import * as yup from "yup";
import ModalComponent from "../../../../../core/components/modal/modal.component";
import TableComponent from "../../../../../core/components/table/table.component";
import FilterFormComponent, {
  FilterFormConfig,
} from "../../../../../shared/filter-form/filter-form.component";
import FormBuilderComponent, {
  FormConfig,
} from "../../../../../shared/form-builder/form-builder.component";
import {
  enableCertificate,
  getCertificates,
  getDeviceCertificateFile,
  renewCertificate,
  restrictCertificate,
  revokeCertificate,
  setFilter,
} from "../../../../../store/slices/certificate.slice";
import { getCertificateDeviceList } from "../../../../../store/slices/dms-device.slice";
import SearchBarComponent from "../../search-bar/search-bar.component";
import DMSCommonCertificateComponent from "./dms-common-certificate.component";
import { getUserInfo } from "src/core/auth/auth.service";
import "../dms.scss";
import "../../../admin.scss";

interface DMSCertificateTableComponentProps {
  columns: any;
  data: any[];
  totalNumberOfRecords: number;
  pageSize: number;
  current: number;
  onChangePage: any;
  onChangeSort: any;
  filter: any;
  onRefetchData: (
    deviceCode?: any,
    status?: any,
    fromDate?: any,
    toDate?: any,
  ) => void;
  isLoading: boolean;
  onSearch: (val: string) => void;
}

function isDisabledButton(data: any, label: any): boolean {
  if (data?.status === "Revoked") {
    if (label === "Renew") {
      return true;
    }
    return false;
  } else {
    if (data?.status === "Restricted" && label === "Enable") {
      return true;
    }
    if (data?.status === "Restricted" && label === "Restrict") {
      return false;
    }
    if (data?.status === "Valid" && label === "Restrict") {
      return true;
    }
    if (data?.status === "Valid" && label === "Enable") {
      return false;
    }
    if (
      data?.status === "Invalid" &&
      ["Download", "Restrict", "Enable", "Revoke"].includes(label)
    ) {
      return false;
    }
    if (
      data?.status === "Restricted" &&
      ["Download", "Restrict", "Revoke", "Renew"].includes(label)
    ) {
      return false;
    }
    return true;
  }
}

// function isDisplayButton(data: any, label: any): boolean {
//   if (data?.status === "Revoked") {
//     if (label === "Renew") {
//       return true;
//     }
//     return false;
//   } else {
//     if (data?.status === "Restricted" && label === "Enable") {
//       return true;
//     }
//     if (data?.status === "Restricted" && label === "Restrict") {
//       return false;
//     }
//     if (data?.status === "Valid" && label === "Restrict") {
//       return true;
//     }
//     if (data?.status === "Valid" && label === "Enable") {
//       return false;
//     }
//     if (
//       data?.status === "Invalid" &&
//       ["Download", "Restrict", "Enable", "Revoke"].includes(label)
//     ) {
//       return false;
//     }
//     if (
//       data?.status === "Restricted" &&
//       ["Download", "Restrict", "Revoke", "Renew"].includes(label)
//     ) {
//       return false;
//     }
//     return true;
//   }
// }

const DMSCertificateTableComponent: FC<DMSCertificateTableComponentProps> = ({
  columns,
  data,
  totalNumberOfRecords,
  pageSize,
  current,
  onChangePage,
  onChangeSort,
  filter,
  onRefetchData,
  isLoading,
  onSearch,
}) => {
  // const [deviceDataOptions, setDeviceDataOptions] = useState<any>([]);
  const [selectedIdToPerformAction, setSelectedIdToPerformAction] =
    useState<number>(0);
  const formRef = createRef();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isDownload, setIsDownload] = useState<boolean>(false);
  const [isRestrict, setIsRestrict] = useState<boolean>(false);
  const [isRevoke, setIsRevoke] = useState<boolean>(false);
  // const [isRenew, setIsRenew] = useState<boolean>(false);
  const [isEnable, setIsEnable] = useState<boolean>(false);
  const [initialValues, setInitialValues] = useState<any>({
    expiredAt: "",
  });
  const [isCommonCertificateModalOpen, setIsCommonCertificateModalOpen] =
    useState(false);

  const [tcOptions, setTCOptions] = useState<any>([]);
  const [siteOptions, setSiteOptions] = useState<any>([]);
  const [blockOptions, setBlockOptions] = useState<any>([]);

  const [assetOptions, setAssetOptions] = useState<any>([]);
  const [isAssetSearch, setIsAssetSearch] = useState<boolean>(true);

  const [selectedTC, setSelectedTC] = useState<any>(null);
  const [selectedSite, setSelectedSite] = useState<any>(null);
  const [selectedBlock, setSelectedBlock] = useState<any>(null);
  const [blockChangeDetected, setBlockChangeDetected] = useState(0);

  const [filterUpdateCount, setFilterUpdateCount] = useState(0);
  // const [deviceOptions, setDeviceOptions] = useState<any>([
  //   {
  //     label: "SJ-560441-01010754",
  //     value: "SJ-560441-01010754",
  //   },
  //   {
  //     label: "SJ-560442-01010000",
  //     value: "SJ-560442-01010000",
  //   },
  //   {
  //     label: "SJ-560442-01010000",
  //     value: "SJ-560442-01010000",
  //   },
  // ]);

  const [statusOptions] = useState<any>([
    {
      label: "Valid",
      value: "Valid",
    },
    {
      label: "Restricted",
      value: "Restricted",
    },
    {
      label: "Revoked",
      value: "Revoked",
    },
  ]);

  const dispatch = useDispatch();
  const userInfo = getUserInfo();
  // HDB Admin (role id 1) and SLP Operator (role id 9)
  const showCommonCertificates = [1, 9].includes(Number(userInfo?.roleid));

  useEffect(() => {
    // dispatch(getDMSDeviceList());
    dispatch(getTownCouncils({ PageNumber: 0, pageSize: 0 }));
    dispatch(getCertificateDeviceList());
  }, [dispatch]);

  // const dmsDeviceListData = useSelector((state: any) => {
  //   return state.dmsDevice.dmsDevicesList;
  // });

  // const isLoadingDmsDeviceList = useSelector((state: any) => {
  //   return state.dmsDevice.isLoadingDmsDeviceList;
  // });

  const townCouncilData = useSelector((state: any) => {
    return state.townCouncil.townCouncils;
  });

  const siteDataByTCCode = useSelector((state: any) => {
    return state.locationSite.sitesByTCCode;
  });

  const blockDataSiteCode = useSelector((state: any) => {
    return state.locationBlock.blocksBySiteCode;
  });

  const isLoadingTownCouncils = useSelector((state: any) => {
    return state.townCouncil.isLoadingTownCouncils;
  });

  const isLocationSitesByTCCode = useSelector((state: any) => {
    return state.locationSite.isLocationSitesByTCCode;
  });

  const isLoadingBlocksBySiteCode = useSelector((state: any) => {
    return state.locationBlock.isLoadingBlocksBySiteCode;
  });

  const assetsData = useSelector((state: any) => {
    return state.dmsDashboard.deviceByBlock;
  });

  // useEffect(() => {
  //   const dmsDD = dmsDeviceListData?.data?.map((dd: any) => ({
  //     label: dd?.deviceCode,
  //     value: dd?.deviceCode,
  //   }));

  //   setDeviceDataOptions(dmsDD);
  // }, [dmsDeviceListData]);

  useEffect(() => {
    if (selectedTC && selectedSite && selectedBlock) {
      dispatch(
        getDeviceByBlock({
          blockCode: selectedBlock,
        }),
      );
    }
  }, [selectedBlock]);

  useEffect(() => {
    const deviceIDs: string[] = assetsData?.map(
      (options: { id: string; sensorDisplayName: string }) => {
        return {
          label: options?.sensorDisplayName,
          value: options?.id,
        };
      },
    );

    if (assetsData.length > 0) {
      setAssetOptions(deviceIDs);
      setIsAssetSearch(false);
    }
  }, [assetsData]);

  const [currentTC, setCurrentTC] = useState({ label: "", value: "" });

  useEffect(() => {
    const tcs = townCouncilData?.data?.map((tc: any) => ({
      label: tc?.name,
      value: tc?.tcCode,
    }));

    if (!tcs) return;

    const optionsWithEmptyString = [
      { label: "Select Town Council *", value: "" },
      ...tcs,
    ];
    // if user is TC Admin only 1 tc is available
    if (tcs?.length === 1) {
      setCurrentTC(tcs[0]);
    }
    // debugger;

    setTCOptions(optionsWithEmptyString);
    setFilterUpdateCount(filterUpdateCount + 1);
  }, [townCouncilData]);

  useEffect(() => {
    if (currentTC.value.length) {
      setFormFilterInitialValues((prev) => ({
        ...prev,
        townCouncil: currentTC.value,
      }));

      // debugger;
      dispatch(getSiteByTCCode({ tcCode: currentTC.value }));
    }
  }, [currentTC]);

  useEffect(() => {
    const sites = siteDataByTCCode?.data?.map((site: any) => ({
      label: site?.name,
      value: site?.siteCode,
    }));

    if (!sites?.length) return;

    const optionsWithEmptyString = [
      { label: "Select Site *", value: "" },
      ...sites,
    ];

    setSiteOptions(optionsWithEmptyString);
  }, [siteDataByTCCode]);

  useEffect(() => {
    const blocks = blockDataSiteCode?.data?.map((block: any) => ({
      label: block?.blockName,
      value: block?.blockCode,
    }));
    if (!blocks) return;

    const optionsWithEmptyString = [
      { label: "Select Block *", value: "" },
      ...blocks,
    ];

    setBlockOptions(optionsWithEmptyString);
  }, [blockDataSiteCode]);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsCommonCertificateModalOpen(false);
    setIsDownload(false);
    setIsRestrict(false);
    setIsRevoke(false);
    // setIsRenew(false);
    setIsEnable(false);

    setInitialValues({
      expiredAt: "",
    });
  };

  const handleRestrictOk = () => {
    setIsModalOpen(false);
    setIsDownload(false);
    setIsRestrict(false);
    setIsRevoke(false);
    // setIsRenew(false);
    setIsEnable(false);

    setInitialValues({
      expiredAt: "",
    });

    dispatch(
      restrictCertificate({ certificateId: selectedIdToPerformAction }),
    ).then(() => {
      onRefetchData();
    });
  };

  const handleEnableOk = () => {
    setIsModalOpen(false);
    setIsDownload(false);
    setIsRestrict(false);
    setIsRevoke(false);
    // setIsRenew(false);
    setIsEnable(false);

    setInitialValues({
      expiredAt: "",
    });

    dispatch(
      enableCertificate({ certificateId: selectedIdToPerformAction }),
    ).then(() => {
      onRefetchData();
    });
  };

  const handleRevokeOk = () => {
    setIsModalOpen(false);
    setIsDownload(false);
    setIsRestrict(false);
    setIsRevoke(false);
    // setIsRenew(false);
    setIsEnable(false);

    setInitialValues({
      expiredAt: "",
    });

    dispatch(
      revokeCertificate({ certificateId: selectedIdToPerformAction }),
    ).then(() => {
      onRefetchData();
    });
  };

  const downloadAction = (id: number) => {
    setIsModalOpen(true);
    setIsDownload(true);
    setIsRestrict(false);
    setIsRevoke(false);
    // setIsRenew(false);
    setIsEnable(false);

    setSelectedIdToPerformAction(id); // new
  };

  const restrictAction = (id: number) => {
    setIsModalOpen(true);
    setIsDownload(false);
    setIsRestrict(true);
    setIsRevoke(false);
    // setIsRenew(false);
    setIsEnable(false);

    setSelectedIdToPerformAction(id);
  };

  const enableAction = (id: number) => {
    setIsModalOpen(true);
    setIsDownload(false);
    setIsRestrict(false);
    setIsRevoke(false);
    // setIsRenew(false);
    setIsEnable(true);

    setSelectedIdToPerformAction(id);
  };

  const revokeAction = (id: number) => {
    setIsModalOpen(true);
    setIsDownload(false);
    setIsRestrict(false);
    setIsRevoke(true);
    // setIsRenew(false);
    setIsEnable(false);

    setSelectedIdToPerformAction(id);
  };

  const renewAction = (id: number) => {
    setIsModalOpen(true);
    setIsDownload(false);
    setIsRestrict(false);
    setIsRevoke(false);
    // setIsRenew(true);
    setIsEnable(false);

    setSelectedIdToPerformAction(id);
  };

  const onSubmitRenew = () => {
    const form: any = formRef.current;

    if (form) {
      form.handleSubmit();

      const formValues = form.values;
      const payload = {
        ...formValues,
        certificateId: selectedIdToPerformAction,
      };

      dispatch(renewCertificate({ payload })).then(() => {
        onRefetchData();
      });
    }

    handleCloseModal();
  };

  const onSubmitFilter = () => {
    const form: any = formRef.current;

    form.handleSubmit();

    const { townCouncil, site, fromDate, toDate } =
      form.values;

    if (toDate) {
      if (toDate < fromDate) {
        return;
      }
    }

    if (townCouncil && site) {
      dispatch(setFilter(form.values));
    }
  };

  const onReset = () => {
    const form: any = formRef.current;
    form.resetForm();

    setFormFilterInitialValues({
      townCouncil: "",
      site: "",
      block: "",
      device: 0,
      fromDate: "",
      toDate: "",
      status: "",
    });

    setFilterUpdateCount(filterUpdateCount + 1);

    dispatch(setFilter({}));

    // onRefetchData(null, null, null, null);
    setAssetOptions([]);
    setSiteOptions([]);
    setBlockOptions([]);
    setIsAssetSearch(true);
    setBlockChangeDetected(0);
    setSelectedBlock(null);
  };

  const onClickDownload = () => {
    dispatch(
      getDeviceCertificateFile({
        certificateId: selectedIdToPerformAction,
      }),
    ).then(() => {
      handleCloseModal();
    });
  };

  const [formFilterInitialValues, setFormFilterInitialValues] = useState({
    townCouncil: filter?.townCouncil || "",
    site: filter?.site || "",
    block: filter?.block || "",
    device: filter?.device || 0,
    fromDate: filter?.fromDate || "",
    toDate: filter?.toDate || "",
    status: filter?.status || "",
  });

  const getCertificateModalActionConfig = (): any => {
    if (isDownload) {
      return [
        {
          label: "Download",
          event: onClickDownload,
          variant: "primary",
        },
      ];
    }
    if (isRestrict) {
      return [
        {
          label: "Yes",
          event: handleRestrictOk,
          variant: "primary",
        },
      ];
    }
    if (isEnable) {
      return [
        {
          label: "Yes",
          event: handleEnableOk,
          variant: "primary",
        },
      ];
    }
    if (isRevoke) {
      return [
        {
          label: "Yes",
          event: handleRevokeOk,
          variant: "primary",
        },
      ];
    }
    return [
      {
        label: "Ok",
        event: onSubmitRenew,
        variant: "primary",
      },
    ];
  };

  const modalActionConfig = getCertificateModalActionConfig();

  const filterActionConfig: any = {
    label: "Filter",
    event: onSubmitFilter,
    variant: "primary",
  };

  const reset: any = {
    label: "Reset",
    event: onReset,
    variant: "secondary",
  };

  const actionConfig: any = [
    {
      label: "Download",
      actionProperty: "certificateId",
      event: downloadAction,
      variant: "secondary",
      className: "mx-2 my-1",
      isDisabled: isDisabledButton,
      moduleName: "Certificate",
      actionName: "Download-Certificate",
    },
    {
      label: "Restrict",
      actionProperty: "certificateId",
      event: restrictAction,
      variant: "danger",
      className: "mx-2 my-1",
      isDisabled: isDisabledButton,
      moduleName: "Certificate",
      actionName: "Restrict-Certificate",
    },
    {
      label: "Enable",
      actionProperty: "certificateId",
      event: enableAction,
      variant: "danger",
      className: "mx-2 my-1",
      isDisabled: isDisabledButton,
      moduleName: "Certificate",
      actionName: "Enable-Certificate",
    },
    {
      label: "Revoke",
      actionProperty: "certificateId",
      event: revokeAction,
      variant: "info",
      className: "mx-2 my-1",
      isDisabled: isDisabledButton,
      moduleName: "Certificate",
      actionName: "Revoke-Certificate",
    },
    {
      label: "Renew",
      actionProperty: "certificateId",
      event: renewAction,
      variant: "primary",
      className: "mx-2 my-1",
      isDisabled: isDisabledButton,
      moduleName: "Certificate",
      actionName: "Renew-Certificate",
    },
  ];

  const emptyConfig = {
    title: "No Certificate Found",
    description: "",
  };

  const formConfig: FormConfig = {
    controls: [
      {
        name: "expireDate",
        label: "Expired At",
        placeholder: "Select Expiration Date",
        type: "date",
        required: true,
      },
    ],
  };

  const onChangeTC = (selectedTC: any) => {
    setSiteOptions([]);
    setBlockOptions([]);
    setSelectedTC(selectedTC);
    setIsAssetSearch(true);
    setBlockChangeDetected(blockChangeDetected + 1);

    // const form: any = formRef.current;

    // if (form) {
    //   // Get all field names except 'towncouncil'
    //   const fieldNames = Object.keys(form.values).filter(
    //     (name) => name !== "towncouncil"
    //   );

    //   // Reset each field to empty, except 'towncouncil'
    //   fieldNames.forEach((fieldName) => {
    //     if (fieldName === "site" || fieldName === "block") {
    //       form.setFieldValue(fieldName, "", false); // false to avoid validation after setting field
    //     }
    //   });

    //   console.log(form.values); // This will now reflect the reset operation
    // }

    setFormFilterInitialValues({
      ...formFilterInitialValues,
      townCouncil: selectedTC,
      site: "",
      block: "",
    });

    if (!selectedTC) return;

    dispatch(getSiteByTCCode({ tcCode: selectedTC }));
    // onChangeLocation();
  };

  const onChangeSite = (selectedSite: any) => {
    setBlockOptions([]);

    setFormFilterInitialValues({
      ...formFilterInitialValues,
      site: selectedSite,
      block: "",
    });

    setSelectedSite(selectedSite);
    setIsAssetSearch(true);
    setBlockChangeDetected(blockChangeDetected + 1);

    if (!selectedSite) return;
    dispatch(getBlocksBySiteCode({ siteCode: selectedSite }));
  };

  const onChangeBlock = (selectedBlock: any) => {
    setAssetOptions([]);

    setFormFilterInitialValues({
      ...formFilterInitialValues,
      block: selectedBlock,
    });

    setSelectedBlock(selectedBlock);
    setIsAssetSearch(true);
    setBlockChangeDetected(blockChangeDetected + 1);

    if (!selectedBlock) return;
  };

  const onChangeStataus = (selectedStatus: any) => {
    setFormFilterInitialValues({
      ...formFilterInitialValues,
      status: selectedStatus,
    });
  };

  const onChangeStartDate = (fromDate: any) => {
    setFormFilterInitialValues((prevInitValues: any) => ({
      ...prevInitValues,
      fromDate: fromDate,
    }));
  };

  const onChangeEndDate = (toDate: any) => {
    setFormFilterInitialValues((prevInitValues: any) => ({
      ...prevInitValues,
      toDate: toDate,
    }));
  };

  useEffect(() => {
    // Somehow startDate and endDate is not showing in formref that's why this method
    // Alert
    const form: any = formRef.current;
    const startDate = form.values.fromDate;
    const endDate = form.values.toDate;

    setFormFilterInitialValues({
      ...formFilterInitialValues,
      fromDate: startDate,
      toDate: endDate,
    });
  }, [blockChangeDetected]);

  const filterFormConfig: FilterFormConfig = {
    controls: [
      {
        controlGroup: [
          {
            name: "townCouncil",
            placeholder: "Select Town Council *",
            type: "searchable-select",
            options: tcOptions,
            onChange: onChangeTC,
            required: true,
            isLoading: currentTC.value.length
              ? false
              : Boolean(isLoadingTownCouncils),
          },
        ],
      },
      {
        controlGroup: [
          {
            name: "site",
            placeholder: "Select Site *",
            type: "searchable-select",
            options: siteOptions,
            onChange: onChangeSite,
            required: true,
            isLoading: isLocationSitesByTCCode,
          },
        ],
      },
      {
        controlGroup: [
          {
            name: "block",
            placeholder: "Select Block",
            type: "searchable-select",
            options: blockOptions,
            onChange: onChangeBlock,
            // required: true,
            isLoading: isLoadingBlocksBySiteCode,
          },
        ],
      },

      {
        controlGroup: [
          {
            name: "status",
            placeholder: "Select Status",
            type: "searchable-select",
            options: statusOptions,
            onChange: onChangeStataus,
            required: true,
            isLoading: false,
          },
        ],
      },
      {
        controlGroup: [
          {
            name: "fromDate",
            placeholder: "Select Start Date",
            type: "date",
            required: true,
            isLoading: false,
            onChange: onChangeStartDate,
          },
        ],
      },
      {
        controlGroup: [
          {
            name: "toDate",
            placeholder: "Select End Date",
            type: "date",
            required: true,
            isLoading: false,
            onChange: onChangeEndDate,
          },
        ],
      },
      {
        controlGroup: [
          {
            name: "device",
            placeholder: "Device ID",
            type: "searchable-select",
            required: true,
            selectType: "single",
            options: assetOptions,
            isLoading: true,
            disabled: isAssetSearch,
            resetSearchableSelect: blockChangeDetected,
          },
        ],
      },
    ],
  };

  const validationSchema = yup.object().shape({
    townCouncil: yup.string().required("Town Council is required"),
    site: yup.string().required("Site is required"),
    // block: yup.string().required("Block is required"),
    fromDate: yup.date(),
    toDate: yup
      .date()
      .min(yup.ref("fromDate"), "End Date must be after Start Date"),
  });

  const onClickCommonCertificate = () => {
    setIsCommonCertificateModalOpen(true);
  };

  useEffect(() => {
    setSiteOptions([]);
    setBlockOptions([]);
    setAssetOptions([]);
    setIsAssetSearch(true);
    setIsCommonCertificateModalOpen(false);
  }, []);

  const handelCommonCertificate = useCallback((isOpen: boolean): void => {
    setIsCommonCertificateModalOpen(isOpen);
  }, []);

  const getCertificateModalHeaderTitle = () => {
    if (isDownload) return "Download Certificates";
    if (isRestrict) return "Confirm Restrict Certificate";
    if (isRevoke) return "Confirm Revoke Certificate";
    if (isEnable) return "Confirm Enable Certificates";
    return "Renew Certificate";
  };

  const getCertificateModalContent = () => {
    if (isDownload) {
      return (
        <ul className="list-unstyled">
          <li
            className=" text-decoration-underline"
          /* onClick={() => {
            onClickDownload();
          }} */
          >
            <FontAwesomeIcon icon={faFileArrowDown} className="me-2 fs-5" />
            Download Certificates
          </li>
          {/* <li
            className="cursor-pointer text-decoration-underline my-3"
            onClick={() => {
              onClickDownload("device");
            }}
          >
            <FontAwesomeIcon icon={faFileArrowDown} className="me-2 fs-5" />
            Download Device Certificate
          </li>
          <li
            className="cursor-pointer text-decoration-underline"
            onClick={() => {
              onClickDownload("key");
            }}
          >
            <FontAwesomeIcon icon={faFileArrowDown} className="me-2 fs-5" />
            Download Certificate Key
          </li> */}
        </ul>
      );
    }
    if (isRestrict) {
      return (
        <p>
          If you restrict the certificate then the gateway will no longer be
          able to connect the <br /> system until enabled back. Do you
          really want to proceed?
        </p>
      );
    }
    if (isEnable) {
      return (
        <p>
          If you enable the certificate then the gateway will be able to
          connect the <br /> system again. Do you really want to proceed?
        </p>
      );
    }
    if (isRevoke) {
      return (
        <p>
          If you revoke the certificate this will disconnect the gateway
          from the system. And the gateway <br /> will no longer be able to
          connect until new certificate issued. Do you really want to
          proceed?
        </p>
      );
    }
    return (
      <FormBuilderComponent
        formRef={formRef}
        initialValues={initialValues}
        validation={validationSchema}
        formConfig={formConfig}
      />
    );
  };

  return (
    <div>
      <div>
        <FilterFormComponent
          key={formFilterInitialValues?.townCouncil}
          formRef={formRef}
          initialValues={formFilterInitialValues}
          formConfig={filterFormConfig}
          actionConfig={filterActionConfig}
          resetButton={reset}
          filterUpdateCount={filterUpdateCount}
          validation={validationSchema}
        />
      </div>
      <div>
        <div className="my-3">
          <div className="d-flex gap-3 justify-content-between table-generic-action table-toolbar pb-3">
            <div className="d-flex gap-3 button-group">
              {showCommonCertificates && (
                <B2Button variant="primary" onClick={onClickCommonCertificate}>
                  Common Certificate
                </B2Button>
              )}
            </div>
            <SearchBarComponent
              placeholder="Search Certificate"
              methodToDispatch={getCertificates}
              getSearch={onSearch}
            />
          </div>
          <TableComponent
            tableHeaders={columns}
            emptyConfig={emptyConfig}
            data={data}
            totalNumberOfRecords={totalNumberOfRecords}
            pageSize={pageSize}
            current={current}
            onChangePage={onChangePage}
            actionConfig={actionConfig}
            onChangeSort={onChangeSort}
            isLoadingData={isLoading}
          />
        </div>
      </div>

      {/* modals */}

      {isModalOpen && (
        <ModalComponent
          isConformationModal={isRestrict || isRevoke}
          showModal={isModalOpen}
          handleClose={handleCloseModal}
          headerTitle={getCertificateModalHeaderTitle()}
          actionConfig={modalActionConfig}
        >
          {getCertificateModalContent()}
        </ModalComponent>
      )}

      {isCommonCertificateModalOpen && (
        <DMSCommonCertificateComponent
          handelCloseModel={handelCommonCertificate}
        />
      )}
    </div>
  );
};

export default DMSCertificateTableComponent;
